import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Field, reduxForm, propTypes as formPropTypes } from 'redux-form';
import ReduxFormField from '../common/forms/ReduxFormsField';

const validate = values => {
  const errors = {};
  const { giftSubscriptionPrice } = values;

  if (!giftSubscriptionPrice || giftSubscriptionPrice < 0.5) {
    errors.giftSubscriptionPrice = ['Gift Subscription Price must be at least $0.50'];
  }

  return errors;
};

class EditSettingsForm extends Component {
  static propTypes = {
    ...formPropTypes,
    publicCourses: PropTypes.object.isRequired,
    shows: PropTypes.object.isRequired,
    onCancel: PropTypes.func.isRequired,
  };

  renderOptionsList(entities) {
    return entities
      .map((entity, key) => {
        return (
          <option value={entity.get('id').toString()} key={key}>
            {entity.get('name')}
          </option>
        );
      })
      .unshift(<option value="" key="not-selected" />);
  }

  render() {
    const { courses, handleSubmit, onCancel, onSubmit, publicCourses, shows, submitting } = this.props;

    return (
      <div className="admin-paper__edit-content">
        <form className="settings-form" onSubmit={handleSubmit(onSubmit)}>
          <Field name="featuredCourseId" component={ReduxFormField} label="Published Featured Course:" required={true}>
            <select>{this.renderOptionsList(publicCourses)}</select>
          </Field>
          <Field
            name="featuredMsCourseId"
            component={ReduxFormField}
            label="Published Featured Movement Specialist Course:"
            required={true}
          >
            <select>{this.renderOptionsList(publicCourses)}</select>
          </Field>
          <Field name="featuredShowId" component={ReduxFormField} label="Featured Show:" required={true}>
            <select>{this.renderOptionsList(shows)}</select>
          </Field>
          <Field
            name="msCertificationCourseId"
            component={ReduxFormField}
            label="Movement Specialist Certification Course:"
            required={true}
          >
            <select>{this.renderOptionsList(courses)}</select>
          </Field>
          <Field name="sixtyDayCourseId" component={ReduxFormField} label="60-Day Course:" required={true}>
            <select>{this.renderOptionsList(courses)}</select>
          </Field>
          <Field
            name="giftSubscriptionPrice"
            component={ReduxFormField}
            label="Gift Subscription Price:"
            required={true}
          >
            <input type="number" />
          </Field>
          <div className="admin-paper__edit-content__button-row flex-end">
            <div>
              <button type="button" className="button button--theme--plain" onClick={onCancel} disabled={submitting}>
                Cancel
              </button>
              <button type="submit" className="button" disabled={submitting}>
                Save
              </button>
            </div>
          </div>
        </form>
      </div>
    );
  }
}

export default reduxForm({
  form: 'editSettingsForm',
  validate,
})(EditSettingsForm);



// WEBPACK FOOTER //
// ./src/settings/EditSettingsForm.js